import { Customer } from '@/types/customer-type';

interface ReceiptCustomerProps {
  customer?: Customer;
  paymentMethod?: string;
  shippingAddress?: string | null;
}

export function ReceiptCustomer({ customer, paymentMethod, shippingAddress }: ReceiptCustomerProps) {
  return (
    <div className="receipt-customer">
      <div className="px-3 py-1.5 space-y-1">
        {customer && (
          <div className="space-y-1">
            {/* Customer + Location Row */}
            <div className="flex flex-col items-start justify-between">
              <div className="flex flex-col items-start flex-1 min-w-0">
                <span >
                  Customer:
                </span>
                <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 min-w-0 text-lg font-bold">
                  <span className="leading-tight break-words">
                    {customer.name}
                  </span>
                  {customer.phone && (
                    <span className="leading-tight break-words">
                      ({customer.phone})
                    </span>
                  )}
                </div>
              </div>

              {shippingAddress && (
                <div className="flex items-center gap-1.5 flex-shrink-0 justify-end">
                  <span className="leading-tight break-words text-lg font-bold">
                    {shippingAddress}
                  </span>
                </div>
              )}
            </div>

            {/* Payment Row */}
            {paymentMethod && (
              <div className="flex items-center justify-between pt-0.5">
                <span className="uppercase tracking-wide text-xs">
                  Payment
                </span>
                <span className="text-xs">{paymentMethod}</span>
              </div>
            )}
          </div>
        )}

        {!customer && paymentMethod && (
          <div className="flex justify-between items-center">
            <span className="uppercase tracking-wide text-xs">
              Payment
            </span>
            <span className="text-xs">{paymentMethod}</span>
          </div>
        )}
      </div>
      <div className="border-b border-black"></div>
    </div>
  );
}
